export function calculateDepositPercent(amount, term, rate, daysInYear) {
    return amount * (rate / 100) * (term / daysInYear);
}
